import React from 'react'
import { Field, ErrorMessage, FieldArray } from 'formik'
import { Row, Col, Card, CardBody, Label } from "reactstrap";

const ReeferCargoType = ({ quotesForm, addContainerValidationSet, validateAddContainer }) => {
  const handleAddContainer = (arrayHelpers) => {
    validateAddContainer(true)
    addContainerValidationSet &&
      arrayHelpers.insert(quotesForm.values.container.length + 1,
        {
          weightPerCargo: '',
          containerSize: '',
          containerType: '',
          temperature: '',
          humidity: '',
          ventilation: '',
          netWeight: ''
        })
  }
  return (
    <>
      <Row className='justify-content-center'>
        <Col className='cargoType-component'>

          <div className='form-group'>
            <FieldArray name='container' render={
              (arrayHelpers) => {
                return <div>
                  {quotesForm.values.container.map((details, index) => (
                    <div className='mt-2 position-relative' key={index}>
                      <div className='close-icon float-end'>
                        <button className='btn btn-danger close-btn' hidden={quotesForm.values.container.length > 1 ? false : true} type='button' onClick={() => arrayHelpers.remove(index)}>X</button>
                      </div>
                      <div className='card' style={{ padding: 5 }}>
                        <div className='card-body'>
                          <Row>
                            <Col md="3">
                              <div className='form-group mb-3'>
                                <Label>Container Type<span>*</span></Label>
                                <Field component="div" className='selector' name={`container.${index}.containerType`}>
                                  <div className="container-item">
                                    <input
                                      checked={quotesForm.values.container[index].containerType === 'GP' ? true : false}
                                      type="radio"
                                      id={`containerType.GP.${index}`}
                                      name={`container.${index}.containerType`}
                                      value="GP"
                                      onChange={() => { }}
                                    />
                                    <Label htmlFor={`containerType.GP.${index}`} className='required-field' onClick={() => quotesForm.setFieldValue(`container.${index}.containerType`, 'GP')}>GP</Label>
                                  </div>
                                  <div className="container-item">
                                    <input
                                      checked={quotesForm.values.container[index].containerType === 'HC' ? true : false}
                                      type="radio"
                                      id={`containerType.HC.${index}`}
                                      name={`container.${index}.containerType`}
                                      value="HC"
                                      onChange={() => { }}
                                    />
                                    <Label htmlFor={`containerType.HC.${index}`} className='required-field' onClick={() => quotesForm.setFieldValue(`container.${index}.containerType`, 'HC')}>HC</Label>
                                  </div>
                                </Field>
                                <ErrorMessage
                                  component='span'
                                  className='field_error'
                                  name={`container.${index}.containerType`}
                                />
                              </div>
                            </Col>
                            <Col md="3">
                              <div className='form-group mb-3'>
                                <Label>Container Size<span>*</span></Label>
                                <Field component="div" className='selector' name={`container.${index}.containerSize`}>
                                  <div className="container-item">
                                    <input
                                      checked={quotesForm.values.container[index].containerSize === '20"' ? true : false}
                                      type="radio"
                                      id={`containerSize.20.${index}`}
                                      name={`container.${index}.containerSize`}
                                      value={`20"`}
                                      className='selector-item_radio'
                                      onChange={() => { }}
                                    />
                                    <Label htmlFor={`containerSize.20.${index}`} className='required-field' onClick={() => quotesForm.setFieldValue(`container.${index}.containerSize`, '20"')}>20"</Label>
                                  </div>
                                  <div className="container-item">
                                    <input
                                      checked={quotesForm.values.container[index].containerSize === '40"' ? true : false}
                                      type="radio"
                                      id={`containerSize.40.${index}`}
                                      name={`container.${index}.containerSize`}
                                      value={`40"`}
                                      className='selector-item_radio'
                                      onChange={() => { }}
                                    />
                                    <Label htmlFor={`containerSize.40.${index}`} className='required-field' onClick={() => quotesForm.setFieldValue(`container.${index}.containerSize`, '40"')}>40"</Label>
                                  </div>
                                </Field>
                                <ErrorMessage
                                  component='span'
                                  className='field_error'
                                  name={`container.${index}.containerSize`}
                                />
                              </div>
                            </Col>
                            <Col md="3">
                              <div className='form-group mb-3'>
                                <div className="mb-4 align-items-baseline">
                                  <Col>
                                    <Label htmlFor={`container.${index}.weightPerCargo`}>Gross weight(kg)<span> *</span></Label>
                                  </Col>
                                  <Col className='container-item'>
                                    <Field
                                      onWheel={(e) => e.target.blur()}
                                      type='number'
                                      className='form-control required-field'
                                      name={`container.${index}.weightPerCargo`}
                                      id={`container.${index}.weightPerCargo`}
                                    />
                                  </Col>
                                  <ErrorMessage
                                    component='span'
                                    className='field_error'
                                    name={`container.${index}.weightPerCargo`}
                                  />
                                </div>
                              </div>
                            </Col>
                            <Col md="3">
                              <div className='form-group mb-3'>
                                <div className="mb-4 align-items-baseline">
                                  <Col>
                                    <Label htmlFor={`container.${index}.netWeight`}>Net weight(kg)<span> *</span></Label>
                                  </Col>
                                  <Col className='container-item'>
                                    <Field
                                      onWheel={(e) => e.target.blur()}
                                      type='number'
                                      className='form-control required-field'
                                      name={`container.${index}.netWeight`}
                                      id={`container.${index}.netWeight`}
                                    />
                                  </Col>
                                  <ErrorMessage
                                    component='span'
                                    className='field_error'
                                    name={`container.${index}.netWeight`}
                                  />
                                </div>
                              </div>
                            </Col>
                          </Row>
                          <div className='mb-3'>
                            <Row className="mb-4">
                              <Col sm={4} className='form-group '>
                                <div className='container-item'>

                                  <Label>Temp(°c)<span>*</span></Label>
                                  <Field
                                    onWheel={(e) => e.target.blur()}
                                    type='number'
                                    className='form-control required-field'
                                    name={`container.${index}.temperature`}
                                    id={`container.${index}.temperature`}
                                  />
                                  <ErrorMessage
                                    component='span'
                                    className='field_error'
                                    name={`container.${index}.temperature`}
                                  />
                                </div>
                              </Col>

                              <Col sm={4} className='form-group '>
                                <div className='container-item'>
                                  <Label>Humidity(%)<span>*</span></Label>
                                  <Field
                                    onWheel={(e) => e.target.blur()}
                                    type='number'
                                    className='form-control required-field'
                                    name={`container.${index}.humidity`}
                                    id={`container.${index}.humidity`}
                                  />
                                  <ErrorMessage
                                    component='span'
                                    className='field_error'
                                    name={`container.${index}.humidity`}
                                  />
                                </div>
                              </Col>

                              <Col sm={4} className='form-group'>
                                <div className='container-item'>
                                  <Label>Ventilation(%)<span>*</span></Label>
                                  <Field
                                    onWheel={(e) => e.target.blur()}
                                    type='number'
                                    className='form-control required-field'
                                    name={`container.${index}.ventilation`}
                                    id={`container.${index}.ventilation`}
                                  />
                                  <ErrorMessage
                                    component='span'
                                    className='field_error'
                                    name={`container.${index}.ventilation`}
                                  />
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                  <div className='form-group float-end mt-2'>
                    <button type={'button'} className='primary-button'
                      onClick={() => handleAddContainer(arrayHelpers)}>Add Container</button>
                  </div>
                </div>
              }
            }>
            </FieldArray>
          </div>
        </Col>
      </Row>
    </>
  )
}

export default ReeferCargoType
